import { render, staticRenderFns } from "./platform_branches.vue?vue&type=template&id=4ceba6ab&"
import script from "./platform_branches.vue?vue&type=script&lang=js&"
export * from "./platform_branches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ceba6ab')) {
      api.createRecord('4ceba6ab', component.options)
    } else {
      api.reload('4ceba6ab', component.options)
    }
    module.hot.accept("./platform_branches.vue?vue&type=template&id=4ceba6ab&", function () {
      api.rerender('4ceba6ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/search/platform_branches.vue"
export default component.exports